/*
 * @Author: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @Date: 2023-05-08 09:53:41
 * @LastEditors: DESKTOP-ROEB53E\caiyangjie 1760178806@qq.com
 * @LastEditTime: 2024-02-19 09:53:50
 * @FilePath: \合联\oms\src\api\common.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { buildApi } from "@/libs/api.request";
import i18n from "@/locale";
import { getWarehouse } from "./storage/warehouse";
export const apis = buildApi({
	get: [
		'/finance/currency&getCurrency',
		'/common/customer', '/user/client/getList&getAllClient', '/user/client/getList&getAllClientALL',
		'/common/country', '/common/country&AllFormCountry', '/common/country&AllToCountry',
		'/warehouse/warehouse&getWarehouse', '/common/chargeType&getChargeType',
		'/common/config/packingAirport&getPackingAirport', '/tracker/status&getTrackerStatus',
		'/common/department/companies&getCompanies', '/common/department/companies&getAllCompanies',
		'/common/circuit&getCircuit', '/common/transport/agent&getTransportAgent', '/common/costChargeType',
		'/common/costDblType', '/common/charging', '/common/getAirPort', '/common/method', '/user/account&salesman',
		'/common/expenseItem', '/common/remoteDepth', '/common/warehouseService', '/common/expense',
		'/common/getPackageType', '/common/getMixType', '/common/audit_status', '/common/boardType', '/common/firstLevel&department',
		'/common/workDepartment', '/common/loopType', '/tracker/agent', '/common/traceStatus', '/common/causeType',
		'/common/bindUser&service', '/common/exportType', '/common/exportStatus', '/common/towType', '/common/prediction/warehouse&predictionWarehouse',
		'/common/abnormalStatus', '/common/prediction/platform', '/common/caseType', '/common/contractParam', '/common/timeoutType',
		'/common/:apiType&getCommon','/common/warehouseSelect'
	],
	options: {
		getCurrency: async (api, options) => {
			return (await api({ pageSize: 999 })).data.payload.rows.map(t => Object.assign(t, { label: t['title'], value: t['code'] }))
		},
		toCountry: async ({ apis }) => {
			return (await apis['country']({ allow_arrive: 1 })).data.payload.rows.map(t => Object.assign(t, { label: t['code'], value: t['code'] }))
		},
		toCountryID: async ({ apis }) => {
			return (await apis['country']({ allow_arrive: 1 })).data.payload.rows.map(t => Object.assign(t, { label: t['code'], value: t['id'] }))
		},
		formCountry: async (api) => {
			return (await apis['country']({ allow_depart: 1 })).data.payload.rows.map(t => Object.assign(t, { label: t['code'], value: t['code'] }))
		},
		AllToCountry: async (api) => {
			let options = [{ label: '*', value: '*' }]
			return options.concat((await api({ allow_arrive: 1 })).data.payload.rows.map(t => Object.assign(t, { label: t['code'], value: t['code'] })))
		},
		AllFormCountry: async (api) => {
			let options = [{ label: '*', value: '*' }]
			return options.concat((await api({ allow_depart: 1 })).data.payload.rows.map(t => Object.assign(t, { label: t['code'], value: t['code'] })))
		},
		getAllClient: async (api) => {
			return (await api()).data.payload.rows.map(t => Object.assign(t, { label: t['account'], value: t['id'] }))
		},
		getAllClientALL: async (api) => {
			let options = [{ label: 'ALL', value: '*' }]
			return options.concat((await api()).data.payload.rows.map(t => Object.assign(t, { label: t['account'], value: t['id'] })))
		},
		customer: async (api) => {
			return (await api()).data.payload
		},
		YesNoNumber: async (api) => {
			return [{ label: i18n.t('YES'), value: 1 }, { label: i18n.t('NO'), value: 0 }]
		},
		YesNoNumber2: async (api) => {
			return [{ label: i18n.t('YES'), value: 1 }, { label: i18n.t('NO'), value: 2 }]
		},
		YesNo: async (api) => {
			return [{ label: i18n.t('YES'), value: "YES" }, { label: i18n.t('NO'), value: "NO" }]
		},
		EnableDisableNumber: async (api) => {
			return [{ label: i18n.t('enable'), value: 1 }, { label: i18n.t('disable'), value: 2 }]
		},
		EnableDisable: async (api) => {
			return [{ label: i18n.t('enable'), value: 'ENABLE' }, { label: i18n.t('disable'), value: 'DISABLE' }]
		},
		NormalDisable: async (api) => {
			return [{ label: i18n.t('normal'), value: 'ENABLE' }, { label: i18n.t('disable'), value: 'DISABLE' }]
		},
		getWarehouse: async (api) => {
			return (await api()).data.payload.rows.map(t => Object.assign(t, { label: t['title'], value: t['id'] }))
		},
		getChargeType: async (api) => {
			return (await api()).data.payload
		},
		getPackingAirport: async (api) => {
			return (await api()).data.payload
		},
		getTrackerStatus: async (api) => {
			return (await api({ pageSize: 9999 })).data.payload.rows.map(t => Object.assign(t, { label: t['tracker_code'], value: t['tracker_code'] }))
		},
		DownUp: async (api) => {
			return [{ label: i18n.t('down'), value: 1 }, { label: i18n.t('up'), value: 2 }]
		},
		getCompanies: async (api) => {
			return (await api()).data.payload.map(t => Object.assign(t, { label: t['title'], value: t['id'] }))
		},
		getAllCompanies: async (api) => {
			let options = [{ label: 'ALL', value: '*' }]
			return options.concat((await api()).data.payload.map(t => Object.assign(t, { label: t['title'], value: t['id'] })))
		},
		getCircuit: async (api) => {
			return (await api({ pageSize: 9999 })).data.payload.rows.map(t => Object.assign(t, { label: t['circuit'], value: t['id'] }))
		},
		getTransportAgent: async (api) => {
			return (await api()).data.payload
		},
		costChargeType: async (api) => {
			return (await api()).data.payload
		},
		costDblType: async (api) => {
			return (await api()).data.payload
		},
		charging: async (api, { data }) => {
			return (await api(data)).data.payload
		},
		getAirPort: async (api) => {
			return (await api()).data.payload
		},
		method: async (api) => {
			return (await api()).data.payload.rows.map(t => Object.assign(t, { label: t.method_name + "(" + t.method_code + ")", value: t['method_code'] }))
		},
		salesman: async (api) => {
			return (await api({ standard: "Salesman" })).data.payload.rows.map(t => Object.assign(t, { label: t['realname'] + `(${t['account']})`, value: t['id'] }))
		},
		expenseItem: async (api) => {
			return (await api()).data.payload.rows.map(t => Object.assign(t, { label: t.name + (t.pin ? "(" + t.pin + ")" : ""), value: t['id'] }))
		},
		remoteDepth: async (api) => {
			return (await api()).data.payload
		},
		warehouseService: async (api) => {
			return (await api()).data.payload
		},
		expense: async (api) => {
			return (await api()).data.payload
		},
		getPackageType: async (api) => {
			return (await api()).data.payload
		},
		getMixType: async (api) => {
			return (await api()).data.payload
		},
		audit_status: async (api) => {
			return (await api()).data.payload
		},
		boardType: async (api) => {
			return (await api()).data.payload
		},
		department: async (api) => {
			return (await api()).data.payload
		},
		workDepartment: async (api) => {
			return (await api()).data.payload
		},
		loopType: async (api) => {
			return (await api()).data.payload
		},
		agent: async (api) => {
			return (await api({
				agent_type: "bag",
				status: "YES",
				types: "DELIVERY",
			})).data.payload.rows.map(t => Object.assign(t, { label: t['agent_name'], value: t['agent_name'] }))
		},
		traceStatus: async (api) => {
			return (await api()).data.payload
		},
		causeType: async (api) => {
			return (await api()).data.payload
		},
		service: async (api, params) => {
			let options = (await api({ type: 1 })).data.payload
			if (params.data) {
				if (typeof params.data !== 'object') {
					params.data = [params.data]
				}
				options = [].concat(...params.data.map(t => options[t] || []))
			} else {
				options = []
			}
			console.log(options);
			return options
		},
		exportStatus: async (api) => {
			return (await api()).data.payload
		},
		exportType: async (api) => {
			return (await api()).data.payload
		},
		towType: async (api) => {
			return (await api()).data.payload
		},
		predictionWarehouse: async (api, params) => {
			return (await api(params.data)).data.payload
		},
		abnormalStatus: async (api) => {
			return (await api()).data.payload
		},
		platform: async (api) => {
			return (await api()).data.payload
		},
		caseType: async (api) => {
			return (await api()).data.payload
		},
		contractParam: async (api) => {
			return (await api()).data.payload
		},
		timeoutType: async (api) => {
			return (await api()).data.payload
		},
		getCommon: async (api, params) => {
			console.log(params, 'params');
			return (await api(params.data)).data.payload
		},
		warehouseSelect: async (api) => {
			return (await api()).data.payload
		},
	},
	desc: {
		getCurrency: '获取全部币种',
		getAllClient: '获取全部用户',
		getAllClientALL: '获取全部用户带*',
		customer: '客户名称列表',
		getCompanies: '公司列表',
		getAllCompanies: '公司列表带*',
		AllFormCountry: '起始国带*',
		formCountry: '起始国',
		AllToCountry: '目的国带*',
		toCountry: '目的国',
		toCountryID: '目的国ID',
		YesNoNumber: '是否(0 和 1)',
		YesNoNumber2: '是否(1 和 2)',
		YesNo: '是否(YES 和 NO)',
		getWarehouse: '获取全部仓库',
		getChargeType: '计费原因',
		getPackingAirport: "获取转运机场",
		getTrackerStatus: '获取轨迹代码',
		EnableDisableNumber: '启用禁用(1 和 2)',
		EnableDisable: '启用禁用(ENABLE 和 DISABLE)',
		DownUp: '上下架(1 和 2)',
		getCircuit: '获取派送线路',
		getTransportAgent: '派送代理',
		costChargeType: '成本计费方式',
		costDblType: 'B2B订单类型',
		charging: '计费类型',
		getAirPort: '获取机场',
		method: '运输方式',
		salesman: '业务员',
		expenseItem: '费用科目',
		remoteDepth: '远程程度',
		warehouseService: '仓储服务其他费用',
		expense: '收费项目',
		getPackageType: '装袋类型',
		getSite: '获取站点',
		getMixType: '获取混装类型',
		audit_status: '审核状态',
		boardType: '整板类型',
		department: '部门',
		workDepartment: '工单跟进部门',
		loopType: '闭环类型',
		agent: '派送商',
		traceStatus: '轨迹主状态',
		causeType: 'B2B异常原因类型',
		service: '客服类型,需要传apiData',
		exportStatus: '导出状态',
		exportType: '导出类型',
		NormalDisable: '正常禁用(ENABLE 和 DISABLE))',
		towType: '暂存海外仓类型',
		predictionWarehouse: '预报仓库',
		abnormalStatus: '异常状态',
		platform: '平台',
		caseType: '关注程度',
		contractParam: '合同抬头',
		timeoutType: '超时原因',
		getCommon: '获取公共方法,需要传apiData.apiType',
		warehouseSelect:'自定义导出仓库选择',
	}
})
